import { j as r } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as o } from "../../../node_modules/clsx/dist/clsx.m.js";
import s from "./StepperDot.module.scss.js";
const D = (p) => {
  const { count: a, active: l, size: m = "small", onChange: t, testId: c } = p;
  return /* @__PURE__ */ r.jsx("div", { className: o(s.stepperDot), children: [...Array(a)].map((i, e) => /* @__PURE__ */ r.jsx(
    "div",
    {
      className: o(
        s.stepperDotChild,
        s[m],
        l === e && s.activeStepperDotChild
      ),
      onClick: () => t == null ? void 0 : t(e),
      onKeyDown: () => t == null ? void 0 : t(e),
      role: "button",
      tabIndex: 0,
      "data-testid": `${c}-${e}`
    },
    e
  )) });
};
export {
  D as default
};
//# sourceMappingURL=StepperDot.js.map
